import styled from 'styled-components/macro'

import { Select } from '@loadsmart/loadsmart-ui'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

export const StyledSelect = styled(Select)`
  div[role='presentation']:nth-of-type(2) {
    left: -9px !important;
    top: -4px !important;
    width: 100%;
    max-width: calc(100% - 48px);
  }

  div[role='presentation'].is-focused {
    outline: none;
  }

  svg {
    color: ${toCSSValue('color-neutral-80')};
  }
`

export const DatePickerWrapper = styled.div`
  div:nth-child(1),
  input {
    width: 100%;
  }
`
